import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SignOutDeleteAccountPage } from 'molecules/SignOutDeleteAccountPage/SignOutDeleteAccountPage';

const SignOutPage = props => {
  let userParams = useSelector(data => data.appStateReducer.userStatus);

  useEffect(() => {
    if (userParams.loggedIn) {
      props.history.push('/');
    }
  }, [userParams, props.history]);

  return <SignOutDeleteAccountPage pageFlag={props.history?.location?.state} history={props.history} />;
};

export default SignOutPage;
